import Vue from "vue"
import Vapi from "vuex-rest-api"

const transports = new Vapi({
  axios: Vue.axios,
  queryParams: true,
  state: {
    transport: null,
    transports: [],
    allTransports: [],
  },
})

  // transports
  .get({
    action: "listTransports",
    property: "transports",
    path: ({ showId }) => `/transports/?show=${showId}`,
  })
  .get({
    action: "listAllTransports",
    property: "allTransports",
    path: ({ showId }) => `/transports/?show=${showId}&no_page=1`,
  })
  .post({
    action: "createTransport",
    path: "/transports/",
  })
  .patch({
    action: "updateTransport",
    path: ({ id }) => `/transports/${id}/`,
  })
  .delete({
    action: "destroyTransport",
    path: ({ id }) => `/transports/${id}/`,
  })

  // finalize
  .getStore()

export default transports
